/** Shared account nav items (web header dropdown + mobile sidebar). */
export const ACCOUNT_MENU_ITEMS_BASE = [
    { to: '/orders', label: 'Your Orders', icon: 'bi-bag-check', variant: 'orders' },
    { to: '/my-credits', label: 'My Credit', icon: 'bi-wallet2', variant: 'credits' },
    { to: '/coupons', label: 'Coupons', icon: 'bi-ticket-perforated', variant: 'coupons' },
    { to: '/vip', label: 'VIP', icon: 'bi-award', variant: 'vip' },
];

export function getAccountMenuLinks(profileLabel) {
    return [
        { to: '/profile', label: profileLabel, icon: 'bi-person-circle', variant: 'profile' },
        ...ACCOUNT_MENU_ITEMS_BASE,
    ];
}

/** Mobile drawer: profile row uses the member's display name. */
export function getMobileAccountMenuLinks(displayName) {
    const label =
        displayName && displayName !== 'Your Account' ? displayName : 'Your Account';
    return [
        { to: '/profile', label, icon: 'bi-person', variant: 'profile' },
        ...ACCOUNT_MENU_ITEMS_BASE,
    ];
}
